var React = require('react');

function EnlargeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H6V2H2V6H0V0ZM14 6H6V14H14V6ZM4 4V16H16V4H4ZM14 20H20V14H18V18H14V20Z"}));
}

EnlargeInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = EnlargeInline;

EnlargeInline.default = EnlargeInline;
